<div class="spinner-overlay" *ngIf="isLoading$ | async">
  <mat-spinner></mat-spinner>
</div>

@if (showNotificationPrompt) {
<div class="notification-prompt-backdrop" role="presentation">
  <section class="notification-prompt" role="dialog" aria-modal="true" aria-labelledby="notification-prompt-title">
    <div class="notification-prompt-icon" aria-hidden="true">
      <mat-icon>notifications_active</mat-icon>
    </div>
    <div>
      <h2 id="notification-prompt-title">{{ notificationPromptTitle }}</h2>
      <p>{{ notificationPromptMessage }}</p>
      @if (notificationPromptCanEnable) {
      <p class="notification-prompt-privacy">
        L'attivazione è facoltativa. Consulta la
        <a [routerLink]="['/privacy-policy']" (click)="closeNotificationPrompt()">informativa sulla privacy</a>.
      </p>
      }
    </div>
    <div class="notification-prompt-actions">
      <button mat-stroked-button type="button" (click)="dismissNotificationPrompt()" [disabled]="enablingNotifications">
        Non ora
      </button>
      @if (notificationPromptCanEnable) {
      <button mat-flat-button class="btn" type="button" (click)="enableNotificationsFromPrompt()" [disabled]="enablingNotifications">
        Attiva
      </button>
      } @else {
      <button mat-flat-button class="btn" type="button" (click)="closeNotificationPrompt()">
        Ho capito
      </button>
      }
    </div>
  </section>
</div>
}

@if (maintenanceBlocksApp) {
<main class="maintenance-page">
  <section class="maintenance-panel" aria-labelledby="maintenance-title">
    <div class="maintenance-icon" aria-hidden="true">
      <mat-icon>construction</mat-icon>
    </div>
    <p class="maintenance-kicker">{{ title }}</p>
    <h1 id="maintenance-title">In manutenzione</h1>
    <p>{{ maintenanceStatus.message }}</p>
    <div class="maintenance-actions">
      @if (authService.isAuthenticated()) {
      <button mat-stroked-button type="button" (click)="logoutFromMaintenance()">Esci</button>
      } @else {
      <a mat-flat-button class="btn" [routerLink]="['/login']" [queryParams]="{ maintenanceLogin: '1' }">Accedi</a>
      }
    </div>
  </section>
</main>
} @else {
<mat-sidenav-container class="sidenav-container">
  <mat-sidenav #drawer class="sidenav" mode="over" position="end" [opened]="false">
    <div class="custom-menu">
      <div class="menu-close-container">
        <button mat-icon-button (click)="drawer.close()" class="close-button" aria-label="Chiudi menu">
          <mat-icon aria-hidden="true">close</mat-icon>
        </button>
      </div>

      @if (this.authService.isAuthenticated()) {
      <div class="menu-header">
        <span class="menu-kicker">Navigazione</span>
        <h3>{{ title }}</h3>
      </div>

      <div class="menu-links">
        <a mat-button [routerLink]="['']" routerLinkActive="active-link" [routerLinkActiveOptions]="{ exact: true }"
          ariaCurrentWhenActive="page" (click)="drawer.close()">Home</a>
        @if (authService.user?.role === Role.CLIENTE) {
        <a mat-button [routerLink]="['nuova-prenotazione']" routerLinkActive="active-link" ariaCurrentWhenActive="page" (click)="drawer.close()">Prenota</a>
        <a mat-button [routerLink]="['novita']" routerLinkActive="active-link" ariaCurrentWhenActive="page"
          [attr.aria-label]="newsMenuAriaLabel" (click)="drawer.close()">
          <span class="news-menu-label">Novità @if (unreadNewsCount > 0) { <span class="news-badge" aria-hidden="true">{{ unreadNewsBadgeLabel }}</span> }</span>
        </a>
        <a mat-button [routerLink]="['lista-attesa']" routerLinkActive="active-link" ariaCurrentWhenActive="page" (click)="drawer.close()">Lista d'attesa</a>
        <a mat-button [routerLink]="['le-tue-prenotazioni']" routerLinkActive="active-link" ariaCurrentWhenActive="page" (click)="drawer.close()">Storico</a>
        <a mat-button [routerLink]="['contatti']" routerLinkActive="active-link" ariaCurrentWhenActive="page" (click)="drawer.close()">Contatti</a>
        }
        @else if (authService.user?.role === Role.ADMIN) {
        <a mat-button [routerLink]="['nuova-prenotazione-admin']" routerLinkActive="active-link" ariaCurrentWhenActive="page" (click)="drawer.close()">Nuova prenotazione</a>
        <a mat-button [routerLink]="['gestisci-prenotazioni']" routerLinkActive="active-link" ariaCurrentWhenActive="page" (click)="drawer.close()">Gestisci prenotazioni</a>
        <a mat-button [routerLink]="['gestisci-disponibilita']" routerLinkActive="active-link" ariaCurrentWhenActive="page" (click)="drawer.close()">Gestisci disponibilità</a>
        <a mat-button [routerLink]="['novita']" routerLinkActive="active-link" ariaCurrentWhenActive="page"
          [attr.aria-label]="newsMenuAriaLabel" (click)="drawer.close()">
          <span class="news-menu-label">Novità @if (unreadNewsCount > 0) { <span class="news-badge" aria-hidden="true">{{ unreadNewsBadgeLabel }}</span> }</span>
        </a>
        <a mat-button [routerLink]="['impostazioni']" routerLinkActive="active-link" ariaCurrentWhenActive="page" (click)="drawer.close()">Impostazioni</a>
        <a mat-button [routerLink]="['ego']" routerLinkActive="active-link" ariaCurrentWhenActive="page" (click)="drawer.close()">Ego</a>
        }
        <a mat-button [routerLink]="['profilo']" routerLinkActive="active-link" ariaCurrentWhenActive="page" (click)="drawer.close()">Profilo</a>
      </div>
      }
    </div>
  </mat-sidenav>

  <mat-sidenav-content class="sidenav-content" [class.blurred]="drawer.opened">
    <div class="shell-background"></div>

    <mat-toolbar color="primary" class="toolbar">
      <div class="toolbar-section left">
        @if (isMobile && this.authService.isAuthenticated()) {
        <button mat-icon-button (click)="goBack()" aria-label="Torna indietro">
          <mat-icon aria-hidden="true">arrow_back</mat-icon>
        </button>
        } @else {
        <a [routerLink]="['']" class="brand-lockup">
          <span class="toolbar-title">{{ title }}</span>
        </a>
        }
      </div>

      <div class="toolbar-section center">
        @if (isMobile) {
        <a [routerLink]="['']" class="mobile-brand">
          <span class="mobile-brand-title">{{ title }}</span>
        </a>
        }
        @else if (this.authService.isAuthenticated()) {
        <nav class="nav-links">
          <a mat-button [routerLink]="['']" routerLinkActive="active-link" [routerLinkActiveOptions]="{ exact: true }" ariaCurrentWhenActive="page">Home</a>
          @if (authService.user?.role === Role.CLIENTE) {
          <a mat-button [routerLink]="['nuova-prenotazione']" routerLinkActive="active-link" ariaCurrentWhenActive="page">Prenota</a>
          <a mat-button [routerLink]="['lista-attesa']" routerLinkActive="active-link" ariaCurrentWhenActive="page">Lista d'attesa</a>
          <a mat-button [routerLink]="['le-tue-prenotazioni']" routerLinkActive="active-link" ariaCurrentWhenActive="page">Storico</a>
          <a mat-button [routerLink]="['novita']" routerLinkActive="active-link" ariaCurrentWhenActive="page"
            [attr.aria-label]="newsMenuAriaLabel">
            <span class="news-menu-label">Novità @if (unreadNewsCount > 0) { <span class="news-badge" aria-hidden="true">{{ unreadNewsBadgeLabel }}</span> }</span>
          </a>
          <a mat-button [routerLink]="['contatti']" routerLinkActive="active-link" ariaCurrentWhenActive="page">Contatti</a>
          }
          @else if (authService.user?.role === Role.ADMIN) {
          <a mat-button [routerLink]="['novita']" routerLinkActive="active-link" ariaCurrentWhenActive="page"
            [attr.aria-label]="newsMenuAriaLabel">
            <span class="news-menu-label">Novità @if (unreadNewsCount > 0) { <span class="news-badge" aria-hidden="true">{{ unreadNewsBadgeLabel }}</span> }</span>
          </a>
          <a mat-button [routerLink]="['nuova-prenotazione-admin']" routerLinkActive="active-link" ariaCurrentWhenActive="page">Nuova prenotazione</a>
          <a mat-button [routerLink]="['gestisci-prenotazioni']" routerLinkActive="active-link" ariaCurrentWhenActive="page">Gestisci prenotazioni</a>
          <a mat-button [routerLink]="['gestisci-disponibilita']" routerLinkActive="active-link" ariaCurrentWhenActive="page">Gestisci disponibilità</a>
          <a mat-button [routerLink]="['impostazioni']" routerLinkActive="active-link" ariaCurrentWhenActive="page">Impostazioni</a>
          <a mat-button [routerLink]="['ego']" routerLinkActive="active-link" ariaCurrentWhenActive="page">Ego</a>
          }
          <a mat-button [routerLink]="['profilo']" routerLinkActive="active-link" ariaCurrentWhenActive="page">Profilo</a>
        </nav>
        }
      </div>

      @if (isMobile && this.authService.isAuthenticated()) {
      <div class="toolbar-section right">
        <button mat-icon-button (click)="drawer.toggle()" class="menu-button" aria-label="Apri menu">
          <mat-icon aria-hidden="true">menu</mat-icon>
        </button>
      </div>
      }
      @else {
      <div class="toolbar-section right"></div>
      }
    </mat-toolbar>

    <div class="main-content">
      @if (maintenanceBypassActive) {
      <div class="maintenance-banner maintenance-banner--bypass" role="status">
        <mat-icon aria-hidden="true">lock_open</mat-icon>
        <span>Manutenzione attiva: accesso test abilitato per questo account.</span>
      </div>
      }

      @if (maintenanceDenied && isMaintenanceLoginRoute) {
      <div class="maintenance-banner" role="status">
        <mat-icon aria-hidden="true">construction</mat-icon>
        <span>Manutenzione attiva. Accedi con un account autorizzato per continuare.</span>
      </div>
      }

      <div *ngIf="showInstallBanner" class="install-banner" role="region" aria-label="Installazione app">
        <p class="install-banner-copy">Vuoi installare questa app sul tuo dispositivo?</p>
        <div class="install-banner-actions">
          <button class="btn" (click)="installPwa()">Installa</button>
          <button class="ghost-button" (click)="closeBanner()">Chiudi</button>
        </div>
      </div>

      <div class="content-shell">
        <router-outlet></router-outlet>
      </div>
    </div>

    <footer class="footer">
      <div class="footer-inner">
        <p class="footer-text">&copy; 2025 {{ title }}</p>
        <a [routerLink]="['privacy-policy']" class="footer-link">Informativa sulla privacy</a>
      </div>
    </footer>
  </mat-sidenav-content>
</mat-sidenav-container>
}
